<template>
    <div class="box-body">
      <div class="row" v-if="statusList">
        <div class="col-md-12 col-lg-12">
          <div class="box box-info">
            <div class="box-body">
              <table class="table table-striped" v-loading="loadingProviders">
                <thead>
                  <tr style="'font-size: 15px; text-align:center;">
                    <!--width: ' + (100 / 3) + '%-->
                   <!-- <th :style="'text-align: center; vertical-align: middle' " v-for="item2 in this.$store.state.companyDataStage" :key="item2.idStage + 3">{{item2.stage}}</th>-->
                    <th :style="'text-align: center; vertical-align: middle; width: ' + (100 / 3) + '%' " v-for="item1 in statusList" :key="item1.idCompanyDataStatus">{{item1.description}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style="font-size: 25px; text-align:center" >
                    <!-- <td  class="statusHover" v-for="item in companyDataStatus" :key="item.idCompanyDataStatus" v-on:click="searchStatus(item.idCompanyDataStatus)">{{getCountByStatus(item.idCompanyDataStatus)}}</td> -->
                    <!-- <td  class="statusHover" v-for="(item, index) in companyDataStatus" v-on:click="searchStatus(item.idCompanyDataStatus)">{{getCountByStatus(item.idCompanyDataStatus)}}</td> -->
                    <!--<td  class="statusHover" v-for="item2 in companyDataStage" :key="item2.idStage + 3" v-on:click="searchStage(item2.idStage)">{{getCountByStage(item2.idStage)}}</td>-->
                    <td  class="statusHover" v-for="item1 in companyDataStatus" :key="item1.idCompanyDataStatus" v-on:click="searchStatus(item1.idCompanyDataStatus)">{{getCountByStatus(item1.idCompanyDataStatus)}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="">
        <!-- <div style="margin-bottom: 10px">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">Marcar todos</el-checkbox>
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group v-model="checkedSteps" @change="handleCheckedStepsChange">
              <el-checkbox v-for="item in steps" :label="item" :key="item">{{item}}</el-checkbox>
            </el-checkbox-group>
        </div> -->
        <el-row>
        <div style="margin-bottom:10px; display: flex;">
              <countries-group :filter="filters[3]" :show-all-button="false" @update-filter="updateFilter"/>
          </div>
          </el-row>
        <div style="margin-bottom: 10px">
          <el-row type="flex" class="filters-container" :gutter="20">
            <el-col :span="8">
              <el-input v-model="filters[0].value" placeholder="Buscar"></el-input>
            </el-col>
            <el-col :span="10">
              <el-select multiple v-model="filters[2].value" placeholder="Etapa">
                <el-option
                  v-for="item in companyDataStage"
                  :key="item.stage"
                  :value="item.idStage"
                  :label="item.stage">
                </el-option>
              </el-select>
            </el-col>
            <!--
              <el-col>
                   <el-checkbox-group v-model="filters[2].value">
                   <el-checkbox-button v-for="item in companyDataStage" :label="item.stage" :value="item.idStage" :key="item.stage">{{item.stage}}</el-checkbox-button>
                  </el-checkbox-group>
              </el-col>
            -->
          </el-row>



  </div>

        </div>

        <data-tables  id="tablaProveedores" v-loading="loadingProviders" :data="newProviders" :pagination-props="{ pageSizes: [10, 20, 30] }"  :filters="filters">
          <el-table-column v-if="country==='Argentina'" v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
            </el-table-column>
          <el-table-column v-if="country==='Peru'" v-for="title in titlesPeru" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
            </el-table-column>
          <el-table-column v-if="country!=='Peru'" label="Servicios" :width="150"> <!-- Si peru no va a tener servicios cambiarlo aca, agregar : v-if=country !== 'Peru' -->
              <template slot-scope="scope">
                    <span v-for="(rubro, index) in scope.row.rubros" :key="rubro.idRubro">
                      {{rubro.nombre}}
                      <span v-if="(index + 1) < scope.row.rubros.length">
                        /
                      </span>
                    </span>
              </template>
          </el-table-column>

          <el-table-column label="" :align="'center'" :width="100" :label="'Alta de Usuario'">
            <template slot-scope="scope">
              <el-tooltip v-if="country === 'Argentina'" class="item" effect="dark" content="Ver" placement="top-end">
                <el-button :data-cy="'btn-'+ scope.row.fiscalId" type="primary" icon="el-icon-view" circle @click="goToDetails(scope.row.idCompany,scope.row.idFIT,scope.row.codCountry)"></el-button>
              </el-tooltip>
              <el-tooltip v-if="country==='Peru'" class="item" effect="dark" content="Ver" placement="top-end">
                <el-button type="danger" icon="el-icon-view" circle @click="goToDetails(scope.row.idCompany, scope.row.idFIT, scope.row.codCountry)"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </data-tables>
      </div>
    </div>
</template>

<script>
  require('moment')
  import datepicker from 'vue-date-picker'
  import Vue from 'vue'
  import api from '../../api'
  import ElementUI from 'element-ui'
  import DataTables from 'vue-data-tables'
  import 'element-ui/lib/theme-chalk/index.css'
  import lang from 'element-ui/lib/locale/lang/es'
  import locale from 'element-ui/lib/locale'
  import status from '../../config/data_status'
  import { mapState } from 'vuex'
  import ButtonGroup from './ButtonGroup.vue'

  Vue.use(ElementUI)
  locale.use(lang)
  Vue.use(DataTables)

  const stepOptions = ['Datos Generales', 'Datos Bancarios', 'Datos Impositivos']
  export default {
    name: 'Settings',
    components: {
      datepicker,
      'countries-group': ButtonGroup
    },
    data (router) {
      return {
        newProvidersPeru: [],
        isIndeterminate: true,
        loadingProviders: true,
        checkAll: false,
        checkedSteps: ['Datos Generales', 'Datos Bancarios'],
        steps: stepOptions,
        section: 'AllComments',
        loading: '',
        companyDataStagePeru: [],
        showModal: false,
        showModalComment: false,
        showModalDocumentation: false,
        showModalOperations: false,
        showModalDetails: false,
        showModalAssociatedUsers: false,
        currentCompany: [],
        providers: [],
        CUIT: '',
        RUC: '',
        currentIdRubro: [],
        company: '',
        companyDataStatus: [],
        companyDataStage: [],
        documents: [],
        filteredDocuments: [],
        rubros: [],
        selectedRow: null,
        comment: null,
        country: 'Argentina',
        companyNew: {
          'nombre': '',
          'razonSocial': '',
          // 'corporateMail': '',
          'fiscalId': '',
          'idCompanyStatus': '',
          'idCompanyDataStatus': '',
          'idStage': '',
          'descripcion': ''
        },
        titles: [{                      // Columnas que se van a mostrar
          prop: 'company',
          label: 'Compañía',
          align: 'center'
        },
        {
          prop: 'fiscalId',
          label: 'Identificación Fiscal',
          align: 'center'
        },
        {
          prop: 'idType',
          label: 'Tipo de identificación',
          align: 'center'
        },
        {
          prop: 'creationDate',
          label: 'Fecha de Creación',
          align: 'center'
        },
        /* {
          prop: 'status',
          label: 'Estado',
          align: 'center'
        }, */
        {
          prop: 'companyDataStatus',
          label: 'Estado Empresa',
          align: 'center'
        },
        {
          prop: 'companyStage',
          label: 'Etapa',
          align: 'center'
        }
        /* {
          prop: 'corporateMail',
          label: 'Mail corporativo',
          align: 'center'
        } */ ],
        titlesPeru: [{                      // Columnas que se van a mostrar
          prop: 'company',
          label: 'Compañía',
          align: 'center'
        },
        {
          prop: 'fiscalId',
          label: 'Identificación Fiscal',
          align: 'center'
        },
        {
          prop: 'idType',
          label: 'Tipo de identificación',
          align: 'center'
        },
        {
          prop: 'creationDate',
          label: 'Fecha de Creación',
          align: 'center'
        },
        {
          prop: 'companyDataStatus',
          label: 'Estado Empresa',
          align: 'center'
        },
        {
          prop: 'companyStage',
          label: 'Etapa',
          align: 'center'
        }
        ],
        filters: [
          {
            prop: ['company', 'fiscalId', 'companyDataStatus'],
            value: ''
          },
          {
            prop: ['idCompanyDataStatus'],
            value: ''
          },
          {
            prop: ['idStage'],
            value: ''
          },
          {
            prop: 'codCountry',
            value: ''
          }
        ],
        titlesOperations: [{                      // Columnas que se van a mostrar
          prop: 'nic',
          label: 'OC'
        },
        {
          prop: 'fecha_liberacion',
          label: 'Liberación'
        }],
        titlesAssociatedUsers: [{                      // Columnas que se van a mostrar
          prop: 'name',
          label: 'Usuarios Asociados'
        }],
        filtersOperations: [
          {
            prop: ['nic'],
            value: ''
          },
          {
            filterFn: (row, filter) => {
              return Object.keys(row).some(prop => {
                if (prop === 'fecha_liberacion') {
                  if (filter.value !== null) {
                    return (new Date(row.fecha_liberacion).getTime() <= filter.value[1].getTime() && new Date(row.fecha_liberacion).getTime() >= filter.value[0].getTime())
                  } else {
                    return true
                  }
                }
              })
            },
            prop: ['fecha_liberacion'],
            value: ''
          },
          {
            prop: 'idCompanyDataStatus',
            value: ''
          },
          {
            prop: 'idStage',
            value: ''
          }
        ],
        filtersAssociatedUsers: [
          {
            prop: ['name'],
            value: ''
          }
        ]
      }
    },
    computed: {
      ...mapState([
        'user'
      ]),
      datetime () {
        return new Date()
      },
      newProviders () {
        return this.providers.filter(prov => prov.idCompanyDataStatus === status.ESPERANDO_CONFIRMACION ||
                                             prov.idCompanyDataStatus === status.DEVUELTO ||
                                             prov.idCompanyDataStatus === status.MODIFICADO)
        // return this.$store.state.providers
      },
      statusList () {
        return this.$store.state.companyDataStatus.filter(el => el.idCompanyDataStatus !== status.ACEPTADO)
      },
      stageList () {
        return this.$store.state.companyDataStage
      },
      bothButtonType () {
        return this.country === 'All' ? 'primary' : ''
      },
      argButtonType () {
        return this.country === 'Argentina' ? 'primary' : ''
      },
      peruButtonType () {
        return this.country === 'Peru' ? 'primary' : ''
      },
      idTypeName () {

      }
    },
    methods: {
      updateFilter (updatedFilter) {
        this.filters[3].value = updatedFilter.value
      },
      handleCheckAllChange (val) {
        this.checkedSteps = val ? stepOptions : []
        this.isIndeterminate = false
      },
      handleCheckedStepsChange (value) {
        let checkedCount = value.length
        this.checkAll = checkedCount === this.steps.length
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.steps.length
      },
      getCompanyStage () {
        api.request('GET', 'api/generic/companyStage')
        .then(response => {
          this.companyDataStage = response.data
        })
      },
      allProviders () {
        api.request('GET', 'api/listCompany')
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            this.providers = data
            this.loadingProviders = false
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
      },
      getCountByStatus (statusId) {
        const argProviders = this.providers.filter(el => el.codCountry === 'AR')
        const perProviders = this.providers.filter(el => el.codCountry === 'PE')
        if (statusId !== '2' && this.country === 'Argentina') {
          return argProviders.filter(el => el.idCompanyDataStatus === statusId).length
        }
        if (statusId !== '2' && this.country === 'Peru') {
          return perProviders.filter(el => el.idCompanyDataStatus === statusId).length
        } else {
          return this.providers.filter(el => el.idCompanyDataStatus === statusId).length
        }
      },
      getCountByStage (stageId) {
        return this.providers.filter(el => el.idStage === stageId && el.idCompanyDataStatus !== status.ACEPTADO).length
      },
      goToDetails (idCompany, idFIT, codCountry) {
        if (idFIT === '1') {
          this.$router.push('/confirmProvider/' + codCountry + '/' + idCompany)
        }
        if (idFIT === '2') {
          this.$router.push('/confirmProviderPeru/' + codCountry + '/' + idCompany) // TODAVIA NO EXISTE
        }
      },
      searchStatus (status) {
        this.filters[1].value = [status]
      },
      searchStage (stage) {
        this.filters[2].value = [stage]
      },
      getStatusName (idCompanyDataStatus) {
        return this.statusList.find(el => el.idCompanyDataStatus === idCompanyDataStatus).description
      },
      showDetails (row) {
        this.currentCompany = row
        this.currentIdRubro = []
        if (this.currentCompany.rubros !== undefined) {
          this.currentCompany.rubros.forEach((item, index) => {
            this.currentIdRubro[index] = item.idRubro
          })
        }
        this.showModalDetails = true
      },
      getCompanyDataStatus () {
        api.request('GET', 'api/generic/companyDataStatus')
        .then(response => {
          this.companyDataStatus = response.data.filter(el => el.idCompanyDataStatus !== status.ACEPTADO)
        })
      },
      getDocumentation (row) {
        this.currentCompany = row
        this.company = row
        api.request('GET', 'api/generic/document')
        .then(response => {
          this.documents = response.data
          this.documents.forEach(doc => {
            if (this.company.documents.find(el => el.idDocument === doc.idDocument) === undefined) {
              this.company.documents.push({'idDocument': doc.idDocument, 'documentName': doc.documentName, 'idProvider': this.company.idCompany, 'status': '0'})
            }
          })
          this.documents.forEach((document, index) => {
            this.filteredDocuments[index] = this.currentCompany.documents.find(el => el.id === '2' && el.idDocument === String(index + 1))
          })
          this.showModalDocumentation = true
        })
      },
      getAssociatedUsers (row) {
        api.request('GET', 'api/AssociatedUsers/' + row.idCompany)
        .then(response => {
          this.showModalAssociatedUsers = true
          this.company = row
          this.company.users = response.data
        })
        .catch(error => {
          console.log(error)
        })
      },
      stopCompany (row) {
        this.$confirm('¿Realmente desea suspender la compañía?', 'Advertencia', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancelar',
          type: 'warning',
          lockScroll: false
        })
        .then(() => {
          api.request('GET', 'api/updateStopCompanyStatus/' + row.idCompany)
          .then(response => {
            this.$parent.getProviders()
          })
        })
      },

      startCompany (row) {
        this.$confirm('¿Desea Activar la compañía?', 'Advertencia', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancelar',
          type: 'warning',
          lockScroll: false
        })
        .then(() => {
          api.request('GET', 'api/updateStartCompanyStatus/' + row.idCompany)
          .then(response => {
            this.$parent.getProviders()
          })
        })
      },
      getRubros () {
        api.request('GET', 'api/generic/rubros')
          .then(response => {
            var data = response.data
            if (data.error) {
              return
            }
            if (data) {
              this.rubros = data
            }
          })
            .catch(error => {
              this.$store.commit('TOGGLE_LOADING')
              console.log(error)
            })
      }
    },
    beforeMount () {
      this.getRubros()
      this.getCompanyDataStatus()
      this.allProviders()
    },
    mounted () {
      // this.allProviders()
      this.getCompanyStage()
    }
}
</script>

<style>
  .datetime-picker input {
    height: 4em !important;
  }

  .calification-reason {
    margin-top: 20px;
    border-radius: 5px;
    background-color: #EEE;
  }

  .height-enter-active {
    transition: all 0.4s ease-in-out;
  }

  .height-enter,
  .height-leave-to {
    transform: scaleY(0);
  }

  .el-dialog_wrapper,
  .el-dialog {
    overflow: hidden !important;
  }

  .el-dialog .el-table {
    height: calc(100vh - 278.87px);
    overflow: auto !important;
  }

.input-label {
    display: inline-block;
    padding: 2px 10px;
  }

  .filters-container_button {
      display:flex;
      justify-content:flex-end;
  }

@media only screen and (max-width: 1000px) {
    .filters-container{
      flex-wrap: wrap;
    }
    .filters-container_button {
      width: 100%;
      margin-top: 8px;
      justify-content: center;
    }
  }
</style>



// WEBPACK FOOTER //
// NewProviders.vue?6ae4d0ac